"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isBrowser = _interopRequireDefault(require("./is-browser"));

/**
 * Checks if the browser has getUserMedia
 *
 * @returns boolean True if the browser supports userMedia false otherwise.
 */
var userMediaCheck = function userMediaCheck() {
  if (!(0, _isBrowser["default"])()) return false;
  return ('getUserMedia', 'mediaDevices' in navigator) && 'getUserMedia' in navigator.mediaDevices;
};

var _default = userMediaCheck;
exports["default"] = _default;